<script setup>
  import { computed } from "vue";

  const props = defineProps({
    item: Object,
  });

  const image = computed(() => {
    return {
      'element': props.item.media['element'],
      'imageUrl': props.item.media['image-url'],
      'imageAlt': props.item.media['image-alt']
    }
  })

</script>

<template>
  <div
    class="element-hero-small-item relative min-h-[40dvh] xl:min-h-none h-full"
  >
    <Media
      :media="image"
    />
  </div>
</template>

<style lang="scss" scoped>
  .element-hero-small-item {
    &::after {
      content: '';
      @apply hidden xl:block absolute top-0 left-0 w-full h-full bg-hero/40;
    }
  }

  :deep(.media-item), :deep(img) {
    @apply w-full h-full min-h-[40dvh];
  }


</style>
